import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';

import { Table, Collapse } from "react-bootstrap";
import { lockerService } from '../../_services';

function List({ match }) {
    const { path } = match;
    const history = useHistory();
    let { venue } = useParams();

    const [lockers, setLockers] = useState(null);

    const fetchData = () => {
        lockerService.getAllForKiosk(venue).then(x => setLockers(x));
    };

    useEffect(() => {
        fetchData();
    }, [history]);

    return (
        <div className="card m-3">
            <div className="card-header header-admin">
                <h1 className="bold-tx">Manage Kiosk {venue}</h1>
                <p> Click a door number to manage the door / rental.</p>
            </div>
            <h3 className="card-header admin-top-bdrline">
                <Link to={'..'} className="btn btn-link">Back</Link>
            </h3>
            <div>
                <Table className="table table-striped" responsive="sm">
                    <thead>
                        <tr>
                            <th className="admin-btm-bdrline">Locker#</th>
                            <th className="admin-btm-bdrline">Size</th>
                            <th className="admin-btm-bdrline">Enabled?</th>
                            <th className="admin-btm-bdrline">Rented?</th>
                            <th className="admin-btm-bdrline">Manage Door</th>

                        </tr>
                    </thead>
                    <tbody>
                        {lockers && lockers.map(locker =>
                            <tr className="admin-top-bdrline " key={locker.id}>
                                <td class="font-weight-bold" ><Link to={`./edit/${locker.id}`}>{locker.guiAdmin}</Link></td>
                                <td>{locker.lockerType}</td>
                                <td>{locker.isEnabled ? "Enabled" : "Disabled"}</td>
                                <td>{locker.reservationId == "0" ? "Not Rented" : locker.reservationId }</td>
                                <td style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'center' }}>
                                    <Link to={`./edit/${locker.id}`}>Manage</Link>
                                </td>

                            </tr>
                        )}
                        {!lockers &&
                            <tr>
                                <td colSpan="4" className="text-center">
                                    <span className="spinner-border spinner-border-lg align-center"></span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
            <h3 className="card-header admin-top-bdrline">
                <Link to={'..'} className="btn btn-link">Back</Link>
            </h3>
        </div>
    );
}

export { List };